import { ISchedule, IScheduleName, IScheduleSchool } from '@app-types/websocket/schedule.types';
import WebSocketClient from '@clients/web-socket.client';

const socket = WebSocketClient.getInstance();

export function createSchedule(data: ISchedule) {
  socket.sendJSON({
    newSchedule: data
  });
}

export function changeScheduleName(data: IScheduleName) {
  socket.sendJSON({
    scheduleName: data
  });
}

export function changeScheduleSchool(data: IScheduleSchool) {
  socket.sendJSON({
    scheduleSchool: data
  });
}




// WEBPACK FOOTER //
// ./src/services/schedule/schedule.websocket.ts